<template>
  <div
    v-if="showIfEmptyOnStage"
    class="card-section"
    :class="{'card-section--library': !!$companyConfiguration.cardSections.getSectionConfig(section.type).fromLibrary}"
  >
    <div class="card-section-header">
      <div class="card-section-header-name">
        {{ $companyConfiguration.cardSections.getSectionConfig(section.type).showName }}
      </div>

      <el-popover
        v-if="$companyConfiguration.cardSections.getSectionConfig(section.type).description"
        placement="top"

        trigger="click"
      >
        <el-button
          slot="reference"
          style="margin-left:10px"
          class="table-action-button danger"
          type="text"
          round
          size="mini"
          icon="fas fa-info-circle"
        ></el-button>

        <div style="white-space: pre-line" v-html="$companyConfiguration.cardSections.getSectionConfig(section.type).description"></div>
      </el-popover>


      <el-button
        v-if="$canAndRulesPass(section, $permissions.CARD_ELEMENT.CREATE)"
        class="add-element-to-section-btn"
        style="margin-left:30px"
        size="mini"
        :type="useNewDesign ? 'primary' : 'default'"
        icon="fas fa-plus"
        @click="addElement"
      >
<!--        Текст кнопки может быть задан в настройках самой секции-->
        {{ $companyConfiguration.cardSections.getSectionConfig(this.section.type).addElementButtonText || $companyConfiguration.i18n.t('card', 'section_add_element_button') }}
      </el-button>
    </div>


    <el-table
      v-if="elementsViewMode === $constants.card.elementsView.TABLE"
      ref="elementsTable"
      class="card-section-elements-table"
      header-row-class-name="card-section-elements-table-header"
      :row-class-name="tableRowClassName"
      :show-header="!!elements.length"
      style="width: 100%"
      border
      :max-height="$companyConfiguration.cardSections.getSectionConfig(section.type).limitHeight ? maxHeightOfSection : null"
      :key="tableKey"
      size="mini"
      :data="elements"
      :empty-text="$companyConfiguration.cardSections.getSectionConfig(section.type).emptyText"
      v-loading="loading"
    >
      <component
        v-for="(columnConfig, index) in columnsConfigs"
        v-if="ifShowColumn(columnConfig)"
        :is="columnConfig.manualColumnTemplate ? columnConfig.template : baseTableColumn"
        :key="index"
        :column-config="columnConfig"
        @elements-changed="elementsChanged"
      >
      </component>
    </el-table>

    <card-section-cards-view
      v-else
      :elements="elements"
      :loading="loading"
      :empty-text="$companyConfiguration.cardSections.getSectionConfig(section.type).emptyText"
      :header-fields="visibleCardViewHeaderFields"
      :body-fields="visibleCardViewBodyFields"
      :item-template="cardViewItemTemplate"
      :element-ids-with-errors="elementIdsWithErrors"
      @elements-changed="elementsChanged"
    />


    <element-add-from-library-dialog
      ref="addElementFromLibraryDialog"
      :from-card="card.id"
      @element-ids-selected="createElementsFromLibrary"
    >
    </element-add-from-library-dialog>

  </div>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit";
import CardElementScaleEditDialog from "@/components/cards/CardElementsBlock/CardElementScaleEditDialog";
import ElementAddFromLibraryDialog from "@/components/cards/CardElementsBlock/ElementAddFromLibraryDialog";
import ElementNameTableColumn from "@/components/tableColumnTemplates/card/ElementNameTableColumn";
import CardSectionCardsView from "@/components/cards/CardElementsBlock/CardSectionCardsView.vue";
import {mapGetters} from "vuex";
import {CardSectionColumnVisibility} from "@/mixins/cardSectionColumnVisibility";

export default {
  name: "card-section",
  mixins: [CardSectionColumnVisibility],
  components: {
    CardSectionCardsView,
    ElementNameTableColumn, ElementAddFromLibraryDialog, CardElementScaleEditDialog, ClickToEdit
  },

  props: {
    section: {type: Object, required: true},
    noPermission: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card',
      effectiveElementsViewMode: 'effectiveElementsViewMode',
    }),
    ...mapGetters('card/stages', {
      stages: 'stages',
      currentStage: 'currentStage',
      currentNegotiation: 'currentNegotiation',
    }),
    ...mapGetters('settings', {
      useNewDesign: 'useNewDesign',
    }),
    ...mapGetters('card/sections', {
      sectionElements: 'sectionElements',
      sectionLoading: 'sectionLoading',
    }),
    ...mapGetters('card/errors', {
      cardErrors: 'errors',
      cardWarnings: 'warnings',
    }),
    elements(){
      return this.sectionElements(this.section.id);
    },
    loading(){
      return this.sectionLoading(this.section.id);
    },

    baseTableColumn() {
      return () => import(`@/components/tableColumnTemplates/BaseTableColumn`);
    },
    hasCardViewConfig() {
      return !!(this.cardViewHeaderConfigs.length || this.cardViewBodyConfigs.length);
    },
    elementsViewMode() {
      if (this.effectiveElementsViewMode === this.$constants.card.elementsView.CARDS && this.hasCardViewConfig) {
        return this.$constants.card.elementsView.CARDS;
      }
      return this.$constants.card.elementsView.TABLE;
    },
    cardViewItemTemplate() {
      return this.$companyConfiguration.cardSections.getCardViewItemTemplate();
    },
    visibleCardViewHeaderFields() {
      return this.cardViewHeaderConfigs.filter((field) => this.ifShowColumn(field));
    },
    visibleCardViewBodyFields() {
      return this.cardViewBodyConfigs.filter((field) => this.ifShowColumn(field));
    },
    showIfEmptyOnStage(){
      if( this.elements.length ){
        return true;
      }
      return !this.$companyConfiguration.cardSections.hideOnStagesIfEmpty(this.section.type, (this.currentStage ? this.currentStage.type : '' ))
    },
    elementIdsWithErrors(){
      let toReturn = [];
      this.cardErrors.forEach((error) => {
        if( error.entityType === 'card_element' && error.entityId ){
          toReturn.push(error.entityId);
        }
      })
      return toReturn;
    },
  },
  data() {
    return {
      maxHeightOfSection: null,
      columnsConfigs: [],
      cardViewHeaderConfigs: [],
      cardViewBodyConfigs: [],
      tableKey: 1,
    }
  },
  beforeMount() {
    this.columnsConfigs = this.$companyConfiguration.helpers.getTableColumnsArrayFromConfig(
      this.$companyConfiguration.cardSections.getSectionColumns(this.section.type)
    );

    const cardView = this.$companyConfiguration.cardSections.getSectionCardView(this.section.type);
    if (cardView) {
      this.cardViewHeaderConfigs = this.$companyConfiguration.helpers.getTableColumnsArrayFromConfig(cardView.header || []);
      this.cardViewBodyConfigs = this.$companyConfiguration.helpers.getTableColumnsArrayFromConfig(cardView.body || []);
    }
  },
  mounted() {
    this.loadElements();
    this.maxHeightOfSection = window.innerHeight - 100;
  },
  methods: {
    loadElements() {
      this.$store.dispatch('card/sections/loadSectionElements', {
        section_id: this.section.id,
        expand: [
          'scale',
          this.noPermission ? '' : 'permissions',
          this.noPermission ? '' : 'fields_permissions',
          'last_comment_by_stage',
          'comments_count_by_stage',
        ].join(),
      })
        .then(() => {
          const scrollState = {
            windowTop: window.scrollY,
            tableLeft: 0,
            tableTop: 0
          };

          if (this.$refs.elementsTable) {
            const tableWrapper = this.$refs.elementsTable.$el.querySelector('.el-table__body-wrapper');
            if (tableWrapper) {
              scrollState.tableLeft = tableWrapper.scrollLeft;
              scrollState.tableTop = tableWrapper.scrollTop;
            }
          }

          // Перерисовываем таблицу, чтобы корректно отображать fixed колонки
          this.tableKey++;

          this.$nextTick(() => {
            if (this.$refs.elementsTable) {
              const tableWrapper = this.$refs.elementsTable.$el.querySelector('.el-table__body-wrapper');
              if (tableWrapper) {
                tableWrapper.scrollLeft = scrollState.tableLeft;
                tableWrapper.scrollTop = scrollState.tableTop;
              }
            }

            window.scrollTo(0, scrollState.windowTop);
          });
        });
    },

    tableRowClassName({row, rowIndex}) {
      if( this.elementIdsWithErrors.includes(row.id) ){
        return 'element-with-error';
      }
      return '';
    },

    addElement() {
      let fromLibraryConfig = this.$companyConfiguration.cardSections.getSectionConfig(this.section.type)['fromLibrary'];
      if (fromLibraryConfig) {
        this.addElementFromLibrary(fromLibraryConfig);
      } else {
        this.createElement();
      }
    },

    createElement() {
      let data = {
        section_id: this.section.id,
      }
      // autofill scale_type if only one in system
      const allowedScaleTypesForSection = this.$companyConfiguration.cardSections.getAllowedScaleTypesForSections(this.section.type);
      if( allowedScaleTypesForSection.length === 1 ){
        data.scale_type = allowedScaleTypesForSection[0];
      }
      this.$api.card.createElement(data)
        .then((data) => {
        })
        .finally(() => {
          this.loadElements();
          this.$emit('elements-changed');
        })
    },


    elementsChanged() {
      this.loadElements();
      this.$emit('elements-changed');
    },


    addElementFromLibrary(libraryType) {
      this.$refs.addElementFromLibraryDialog.open(libraryType);
    },
    createElementsFromLibrary(libraryElementIds) {
      this.$api.card.createElementsFromLibrary({
        section_id: this.section.id,
        element_ids: libraryElementIds,
      })
        .then((data) => {
        })
        .finally(() => {
          this.$refs.addElementFromLibraryDialog.close();
          this.loadElements();
          this.$emit('elements-changed');
        })
    },
  }
}
</script>


<style lang="scss">
@import "@/assets/css/project-variables";

.card-section {
  margin-bottom: 30px;

  &-header {
    font-weight: bold;
    margin-bottom: 14px;

    &-name {
      display: inline-block;
      min-width: 100px;
    }
  }

  .el-table .element-with-error {
    background-color: mix(white, $--color-danger, 90%);
  }
}

</style>